import { formatRelativeTime } from "@utils/formatRelativeTime";
import { format, isValid } from "date-fns";

export const Timestamp: React.FC<{ value: string }> = ({ value }) => {
  const date = new Date(value);
  if (!isValid(date)) return null;
  return (
    <time dateTime={date.toISOString()} title={format(date, "MMM d, yyyy 'at' h:mm a")}>
      {formatRelativeTime(date)}
    </time>
  );
};
